import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { AuthGuard } from './AuthGuard';
import { SidebarProvider, useSidebar, COLLAPSED_WIDTH, EXPANDED_WIDTH } from '../../context/SidebarContext';

function DashboardContent() {
  const { isCollapsed, isHovering } = useSidebar();

  // Main content margin adjusts based on collapsed state
  // We use the collapsed width for margin since hovering expands the sidebar as an overlay
  const marginLeft = isCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH;

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div
        className="flex-1 transition-all duration-300 ease-in-out"
        style={{ marginLeft: `${marginLeft}px` }}
      >
        <Outlet />
      </div>
      {/* Overlay when sidebar is hovering (collapsed but expanded on hover) */}
      {isCollapsed && isHovering && (
        <div className="fixed inset-0 bg-black/10 z-30 pointer-events-none" />
      )}
    </div>
  );
}

export function DashboardLayout() {
  return (
    <AuthGuard>
      <SidebarProvider>
        <DashboardContent />
      </SidebarProvider>
    </AuthGuard>
  );
}
